import { Stack } from "@mantine/core"
import {
  PaginationState,
  RowSelectionState,
  getCoreRowModel,
  getSortedRowModel,
  useReactTable,
} from "@tanstack/react-table"
import { Dispatch, SetStateAction, useState } from "react"

import { ProductResponses } from "@tfg/types/endpoints/products"
import { fetchDataOptionsValidationType } from "@tfg/types/schemas/products"

import { Table } from "~/components/table/Table.tsx"
import { AgecBulkActions } from "~/pages/Brand/Regulations/AGEC/AgecBulkActions.tsx"
import { useAgecColumns } from "~/pages/Brand/Regulations/AGEC/columns.tsx"

interface Props {
  data: ProductResponses.GetProducts
  fetchDataOptions: fetchDataOptionsValidationType
  setPagination: Dispatch<SetStateAction<PaginationState>>
}

export const ProductsAGECTable = ({
  data,
  fetchDataOptions,
  setPagination,
}: Props) => {
  const columns = useAgecColumns()
  const [rowSelection, setRowSelection] = useState<RowSelectionState>({})
  const table = useReactTable({
    state: {
      pagination: fetchDataOptions,
      rowSelection,
    },
    manualPagination: true,
    data: data.products,
    pageCount: Math.ceil(data.totalProducts / fetchDataOptions.pageSize),
    columns,

    onPaginationChange: setPagination,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    onRowSelectionChange: setRowSelection,
  })

  return (
    <Stack>
      <AgecBulkActions table={table} />
      <Table
        table={table}
        pagination={true}
        manualPaginationCount={data.totalProducts}
        pageIndex={fetchDataOptions.pageIndex}
      />
    </Stack>
  )
}
